var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuetifyjs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 293,
    viewBox: "0 0 256 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H68L128 141.816",
    fill: "#1697F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H188L128 141.816",
    fill: "#1867C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 182.744V292.46L0 42.5576H67.049",
    fill: "#7BC6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 182.746V292.461L256 42.5596H188.951",
    fill: "#AEDDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuetifyjs);
export default __webpack_public_path__ + "static/media/vuetifyjs.8a22a3ec81ad62e97094feab6e7ee0fb.svg";
export { ForwardRef as ReactComponent };